import { Box, Card, CardContent, Stack, Typography, useMediaQuery } from "@mui/material";
import DataCard from "../../../components/DataCard";

const HighlightCards = ({ highlights }) => {

    const upLGScreenSize = useMediaQuery((theme) => theme.breakpoints.up('lg'));

    const columnRatio = 1 / highlights.length

    return (
        <Stack direction={{ xs: "column", lg: "row" }} gap={2}>
            {
                upLGScreenSize ?
                    highlights.map((highlight, idx) => {
                        return (
                            <Box key={idx} sx={{ flex: { xs: 1, lg: columnRatio } }}>
                                <Card>
                                    <CardContent>
                                        <Typography variant='h4' fontWeight='bold'>{highlight.value}</Typography>
                                        <Typography color="text.secondary">{highlight.label}</Typography>
                                    </CardContent>
                                </Card>
                            </Box>
                        )
                    })
                    :
                    <DataCard title="Bond highlights" data={highlights} />
            }
        </Stack>

    );
};

export default HighlightCards;